import { useEffect, useState } from "react";
import { toast } from "sonner";
import { listTeam, setRole, CLUB_BASE } from "./clubApi";
import { Card, Pill } from "./ui";

const ROLE = { admin: ["Amministratore", "gold"], incaricata: ["Incaricata", "green"], pending: ["In attesa", "blue"], disattivata: ["Disattivata", "red"] };
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short" }) : "—");

export default function TeamMembers({ me }) {
  const [rows, setRows] = useState([]);
  const load = () => listTeam().then(setRows).catch(() => toast.error("Team non caricato"));
  useEffect(() => { load(); }, []);
  const change = async (u, role) => {
    try { await setRole(u.user_id, role); toast.success(`${u.name}: ${ROLE[role][0]}`); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  const pending = rows.filter((r) => r.role === "pending");
  return (
    <div className="mt-6 space-y-3" data-testid="team-members">
      <p className="text-sm text-[#9A948A]">Chi entra con Google resta «In attesa» finché non lo approvi. Solo incaricate e amministratori vedono i clienti.{pending.length > 0 && <b className="text-[#F5D27A]"> {pending.length} da approvare.</b>}</p>
      {rows.map((u) => {
        const [label, tone] = ROLE[u.role] || ["?", "muted"];
        const isMe = u.user_id === me.user_id;
        return (
          <Card key={u.user_id} className="flex items-center justify-between gap-3 p-4" data-testid={`member-${u.user_id}`}>
            <div className="flex items-center gap-3 min-w-0">
              {u.picture ? <img src={u.picture} alt="" className="h-9 w-9 rounded-full object-cover" referrerPolicy="no-referrer" /> : <div className="h-9 w-9 rounded-full bg-[#E5B13A]/20" />}
              <div className="min-w-0"><p className="font-medium text-sm truncate">{u.name}{isMe ? " (tu)" : ""}</p><p className="text-xs text-[#9A948A] truncate">{u.email} · dal {fmt(u.created_at)} · {CLUB_BASE}/i/{u.slug}</p></div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <Pill tone={tone}>{label}</Pill>
              {!isMe && (
                <select className="rounded-xl border border-[#2E2E34] bg-[#0E0E10] px-2 py-1.5 text-xs text-[#F4EFE6]" value={u.role} onChange={(e) => change(u, e.target.value)} data-testid={`role-select-${u.user_id}`}>
                  <option value="pending">In attesa</option><option value="incaricata">Incaricata</option><option value="admin">Amministratore</option><option value="disattivata">Disattivata</option>
                </select>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
